import {useEffect, useRef, useState} from "react";
import {Leaderboard} from "../data/leaderboard";
import LeaderboardCreation from "./LeaderboardCreation";
import LeaderboardView from "./LeaderboardView";
import {Button} from "primereact/button";
import {Panel} from "primereact/panel";
import {Toast} from "primereact/toast";

function Dashboard(
    {
        onLogoutClick,
    }:
    {
        onLogoutClick(): void;
    }) {

    const [isLoading, setIsLoading] = useState(false);
    const [leaderboards, setLeaderboards] = useState<Leaderboard[]>([]);
    const toast = useRef<Toast>(null)

    useEffect(() => {
        async function fetchLeaderboards() {
            setIsLoading(true);

            try {
                const response = await fetch(
                    `/api/leaderboards`,
                    {
                        credentials: "include",
                    },
                );
                const resData = await response.json();
                const leaderboards = resData.map((element: any) => {
                    return Object.assign(new Leaderboard(), element);
                });

                setLeaderboards(leaderboards);
            } catch (e) {
                toast.current?.show({
                    severity: "error",
                    summary: "Error",
                    detail: "Unable to create a leaderboard.",
                    life: 3000,
                });
            } finally {
                setIsLoading(false);
            }
        }

        fetchLeaderboards();
    }, []);

    function onLeaderboardCreated(leaderboard: Leaderboard) {
        const newSlots = [...leaderboards!, leaderboard];
        setLeaderboards(newSlots);
    }

    return <div>
        <Toast></Toast>
        <div className="flex justify-content-end mb-3">
            <Button
                label="Logout"
                className="w-5 sm:w-3"
                icon="pi pi-sign-out"
                onClick={onLogoutClick}/>
        </div>
        <div className="flex flex-column mb-3 gap-3">
            <Panel header={"Create"}>
                <LeaderboardCreation onLeaderboardCreated={onLeaderboardCreated}/>
            </Panel>
            <Panel header={"Leaderboards"}>
                <LeaderboardView leaderboards={leaderboards}/>
            </Panel>
        </div>
    </div>
}

export default Dashboard;
